
















































import Vue from 'vue'
import Component from 'vue-class-component'
import { vxm } from '@/store'

@Component({
  components: {},
})
export default class Agents extends Vue {
  private isLoading = true
  private agents = []
  private lastActiveTimes = []
  private showLastActiveAt = false

  public created(): void {
    this.load()
  }

  private load() {
    this.isLoading = true
    this.agents = []
    this.lastActiveTimes = []
    this.$axios
      .get('/v4/site/payment/cash-registers/setup/agents' + (this.showLastActiveAt ? '?showLastActiveAt=1' : ''))
      .then((response) => {
        this.isLoading = false
        this.agents = response.data.data.agents
        this.lastActiveTimes = response.data.data.lastActiveTimes
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, 'Error fetching agents')
        this.isLoading = false
      })
  }

  private getLastActiveTimeFormatted(agentId: number): string {
    return this.getLastActiveTime(agentId)
  }

  private getLastActiveTime(agentId: number) {
    for (let i = 0; i < this.lastActiveTimes.length; i++) {
      const at = this.lastActiveTimes[i]
      if (at.agentId === agentId) {
        return at.time
      }
    }
    return null
  }
}
